import { render, staticRenderFns } from "./NewSizeSelectionModal.vue?vue&type=template&id=d9c07cf8"
import script from "./NewSizeSelectionModal.vue?vue&type=script&lang=js"
export * from "./NewSizeSelectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports